import { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import actions from './actions';

class QuantidadeErros extends Component {
  componentDidMount () {
    this.props.actions.onLoadCountErrors();
  }

  render () {
    const { count, fetching } = this.props.value;

    if (1 === fetching) return "Buscando número de erros pendentes...";
    if (2 === fetching && !count) return "Não há erros pendentes registrados.";
    return (2 === fetching?"Número de erros pendentes registrados: " + count:null);
  }
}

let mapStateToProps = ({ quantidadeErros }) => ({
  value: quantidadeErros
});

let mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(QuantidadeErros)


// WEBPACK FOOTER //
// ./src/modules/admin/QuantidadeErros.js